var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCard05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 25,
    viewBox: "0 0 39 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.07,
    d: "M35.75 0.300049H3.75C2.05 0.300049 0.75 1.60005 0.75 3.30005V21.3C0.75 23 2.15 24.3 3.75 24.3H35.75C37.45 24.3 38.75 23 38.75 21.3V3.30005C38.75 1.60005 37.35 0.300049 35.75 0.300049Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.75 1.30005C36.85 1.30005 37.75 2.20005 37.75 3.30005V21.3C37.75 22.4 36.85 23.3 35.75 23.3H3.75C2.65 23.3 1.75 22.4 1.75 21.3V3.30005C1.75 2.20005 2.65 1.30005 3.75 1.30005H35.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.75 19.3C19.616 19.3 22.75 16.166 22.75 12.3C22.75 8.43406 19.616 5.30005 15.75 5.30005C11.884 5.30005 8.75 8.43406 8.75 12.3C8.75 16.166 11.884 19.3 15.75 19.3Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.75 19.3C27.616 19.3 30.75 16.166 30.75 12.3C30.75 8.43406 27.616 5.30005 23.75 5.30005C19.884 5.30005 16.75 8.43406 16.75 12.3C16.75 16.166 19.884 19.3 23.75 19.3Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.75 12.3001C22.75 9.9001 21.55 7.8001 19.75 6.6001C17.95 7.9001 16.75 10.0001 16.75 12.3001C16.75 14.6001 17.95 16.8001 19.75 18.0001C21.55 16.8001 22.75 14.7001 22.75 12.3001Z",
    fill: "#FF5F00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard05);
export default __webpack_public_path__ + "static/media/creditCard_05.41016addb14a86f52a29f62d7c64cc39.svg";
export { ForwardRef as ReactComponent };